module.exports = __webpack_public_path__ + "img/hangye-belt.db8f87dd.png";